import { render, staticRenderFns } from "./index.vue?vue&type=template&id=65ed2d16&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=65ed2d16&prod&lang=less"
import style1 from "./index.vue?vue&type=style&index=1&id=65ed2d16&prod&scoped=true&lang=less"
import style2 from "./index.vue?vue&type=style&index=2&id=65ed2d16&prod&scoped=true&lang=less"
import style3 from "@/assets/h5css/mobile/index.less?vue&type=style&index=3&id=65ed2d16&prod&scoped=true&lang=less&external"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ed2d16",
  null
  
)

export default component.exports